import { atom } from 'jotai';

export const userAtom = atom(null);
export const papersAtom = atom([])
